import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    accessToken: undefined,
    user: undefined,
    loginError: ""
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        userLoggedIn: (state, action) => {
            state.accessToken = action.payload.accessToken;
            state.user = action.payload.user;
            state.loginError = ""
        },
        userLoggedOut: (state) => {
            state.accessToken = undefined;
            state.user = undefined;
            state.loginError = ""
        },
        setLoginError: (state, action) => {
            state.loginError = action.payload;
        }
    },
});

export const { userLoggedIn, userLoggedOut, setLoginError } = authSlice.actions;
export default authSlice.reducer;
